// ===================================================
// config/navigation.presets.js
// Системные пресеты состава rail-хабов (SSOT).
// Personal presets хранятся в user_navigation_preferences.personal_presets.
// ===================================================

/** @typedef {{ id: string, label: string, description: string, hubIds: string[] }} NavSystemPreset */

/** @type {NavSystemPreset[]} */
export const NAVIGATION_SYSTEM_PRESETS = [
  {
    id: 'full',
    label: 'Полное меню',
    description: 'Все доступные разделы по правам и модулям',
    hubIds: [
      'main',
      'products',
      'sales',
      'warehouse',
      'documents',
      'finance',
      'analytics',
      'kassa',
      'integrations',
      'modules',
      'management',
      'cabinet',
      'admin',
    ],
  },
  {
    id: 'trade',
    label: 'Торговля',
    description: 'Каталог, продажи, склад, касса, документы, финансы',
    hubIds: [
      'main',
      'products',
      'sales',
      'warehouse',
      'documents',
      'finance',
      'kassa',
      'integrations',
      'modules',
      'management',
      'cabinet',
      'admin',
    ],
  },
  {
    id: 'services',
    label: 'Услуги',
    description: 'CRM, услуги, документы, финансы, коммуникации',
    hubIds: [
      'main',
      'modules',
      'sales',
      'documents',
      'finance',
      'analytics',
      'management',
      'cabinet',
      'admin',
    ],
  },
  {
    id: 'production',
    label: 'Производство',
    description: 'Товары, склад, документы, аналитика, POWER',
    hubIds: [
      'main',
      'products',
      'warehouse',
      'documents',
      'analytics',
      'modules',
      'finance',
      'management',
      'cabinet',
      'admin',
    ],
  },
  {
    id: 'analytics',
    label: 'Аналитика',
    description: 'Отчёты, финансы, дашборд',
    hubIds: [
      'main',
      'analytics',
      'finance',
      'sales',
      'management',
      'cabinet',
      'admin',
    ],
  },
];

export const DEFAULT_NAV_PRESET_ID = 'full';

export function getSystemPreset(presetId) {
  return (
    NAVIGATION_SYSTEM_PRESETS.find((p) => p.id === presetId) ||
    NAVIGATION_SYSTEM_PRESETS.find((p) => p.id === DEFAULT_NAV_PRESET_ID)
  );
}

export function listSystemPresetIds() {
  return NAVIGATION_SYSTEM_PRESETS.map((p) => p.id);
}

export default NAVIGATION_SYSTEM_PRESETS;
